import { createFileRoute } from "@tanstack/react-router";
import LensPage from "src/components/app/LensPage/LensPage";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { projectLoader } from "src/lib/ScopedLoaders";
import { getLensesPageData } from "src/server/functions/Portal";

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/lenses/$identifier")({
  loader: projectLoader((projectId) => getLensesPageData({ data: projectId })),
  component: LensRoute,
});

function LensRoute() {
  const { identifier } = Route.useParams();
  return (
    <DeferredLoaderData key={identifier} result={Route.useLoaderData()}>
      {(data) => (
        <LensPage
          identifier={identifier}
          projectId={data?.projectId}
          initialLenses={data?.initialLenses}
        />
      )}
    </DeferredLoaderData>
  );
}
